import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ScrEnvironment } from "src/environments/environment";
import { BillingOrder } from "../models/billingorder.model";
import { WithCredNoCache } from "./authentication.service";
import { ScrBaseResponse, ScrBaseService } from "./base.service";
import { ScrServiceManager } from "./servicemanager.service";

class BillingOrderResponse extends ScrBaseResponse {
  public orders!: BillingOrder[];
}


@Injectable({
  providedIn: 'root'
})
export class BillingService extends ScrBaseService {
  constructor(
    serviceManager: ScrServiceManager,
    private environment: ScrEnvironment,
    private http: HttpClient) {
    super(serviceManager);

  }

  getOrders(cannedQuery?: string): Observable<BillingOrderResponse> {
    let url = `${this.environment.base}/secure/billingorder`;
    if (cannedQuery) {
      url = url + "?cannedQuery=" + cannedQuery;
    }
    return this.http.get<BillingOrderResponse>(url, WithCredNoCache);
  }

  getShortCodeDetails(orderId?: number): Observable<BillingOrderResponse> {
    const url = `${this.environment.base}/secure/billingorder/shortCodeDetails/${orderId}`;
  
    return this.http.get<BillingOrderResponse>(url, WithCredNoCache);
  }

  searchAdditionalOrderInfo(searchType: string, id: string): Observable<BillingOrderResponse> {
    const url = `${this.environment.base}/secure/billingorder/lease?${searchType}=${id}`;
    return this.http.get<BillingOrderResponse>(url, WithCredNoCache);
  }

}